export default {
  time: 5000,
};
